<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<div :key="employeeDeparmentIdRoute || 'default'" id="list-employees" class="data-list-container">
		<employee-form-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" @refetchDataList="getListEmployees(true)" :data="sidebarData" />
		<EmployeeResetPasswordDialog v-model="updatePassword" :popupActive="showResetPassPopup" @submitResetPassword="submitResetPassword" @closePopup="toggleResetPasswordPopup" />
		<EmployeeContractForm :isSidebarActive="isShowContractForm" @closeSidebar="toggleContractForm" :data="contractFormData" />
		<EmployeeContractDetailDialog
			v-if="isShowContractDetail"
			:isSidebarActive="isShowContractDetail"
			@closeSidebar="toggleContractDetail"
			@onClickEdit="handleEditContract"
			:employee="contractDetailData.employee"
			:contracts="contractDetailData.contracts"
		/>
		<EmployeeStudentDataForm :isSidebarActive="isShowStudentDataForm" @closeSidebar="toggleStudentDataForm" :data="studentData" />
		<EmployeeStudentPointForm :isSidebarActive="isShowStudentPointForm" @closeSidebar="toggleStudentPointForm" :data="employeeFormData" />

		<department-category-sidebar
			:isSidebarActive="$store.state.departmentManagement.showDepartmentCategorySidebar"
			@closeSidebar="$store.dispatch('departmentManagement/toggleDepartmentCategorySideBar', { status: false })"
		/>

		<!-- <title-category-sidebar
			:isSidebarActive="$store.state.titleManagement.showTitleCategorySidebar"
			@closeSidebar="$store.dispatch('titleManagement/toggleTitleCategorySideBar', { status: false })"
		/> -->
		<roles-category-sidebar
			:isSidebarActive="$store.state.rolesManagement.showRolesCategorySidebar"
			@closeSidebar="$store.dispatch('rolesManagement/toggleRolesCategorySideBar', { status: false })"
		/>
		<div class="dropdown-button-container flex justify-end md:hidden lg:hidden xl:hidden">
			<vs-input @input="mixinHandleSearch" size="small" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />

			<vs-dropdown vs-custom-content vs-trigger-click>
				<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
				<vs-dropdown-menu>
					<vs-dropdown-item v-if="mixinIsCanViewDepartment && mixinIsCanViewTitle">
						<vs-button type="border" class="w-48 font-bold mr-3 whitespace-no-wrap" @click="$store.dispatch('departmentManagement/toggleDepartmentCategorySideBar', { status: true })">
							{{ $t("Department") }} - {{ $t("Title") }}
						</vs-button>
					</vs-dropdown-item>

					<!-- <vs-dropdown-item divider v-if="mixinIsCanViewTitle">
						<vs-button
							type="border"
							class="w-48 font-bold mr-3 whitespace-no-wrap"
							@click="$store.dispatch('titleManagement/toggleTitleCategorySideBar', { status: true })"
							>{{
						}}</vs-button>
					</vs-dropdown-item> -->
					<vs-dropdown-item divider v-if="mixinIsCanViewUserRole">
						<vs-button type="border" class="w-48 font-bold mr-3 whitespace-no-wrap" @click="$store.dispatch('rolesManagement/toggleRolesCategorySideBar', { status: true })">
							{{ $t("RoleManagement") }}
						</vs-button>
					</vs-dropdown-item>
					<vs-dropdown-item divider v-if="mixinIsCanCreateEmployee">
						<vs-button class="w-48 font-bold whitespace-no-wrap" type="filled" @click="addNewData">{{ $t("AddNewEmployee") }}</vs-button>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

		<vs-table ref="table" class="stack-table" :sst="true" :data="employees" :max-items="itemsPerPage" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="w-full">
				<div class="flex flex-grow justify-end">
					<vs-input
						@input="mixinHandleSearch"
						size="large"
						class="input-search mr-3 md:block lg:block xl:block hidden"
						icon="search"
						:placeholder="$t('Actions.Search')"
						v-model="searchText"
					/>
					<div class="md:flex lg:flex xl:flex hidden">
						<vs-button
							v-if="mixinIsCanViewDepartment && mixinIsCanViewTitle"
							type="border"
							class="w-30 font-bold mr-3 whitespace-no-wrap"
							@click="$store.dispatch('departmentManagement/toggleDepartmentCategorySideBar', { status: true })"
						>
							{{ $t("Department") }} - {{ $t("Title") }}
						</vs-button>
						<!-- <vs-button
							v-if="mixinIsCanViewTitle"
							type="border"
							class="w-30 font-bold mr-3 whitespace-no-wrap"
							@click="$store.dispatch('titleManagement/toggleTitleCategorySideBar', { status: true })"
						>
							{{ $t("Title") }}
						</vs-button> -->
						<vs-button
							v-if="mixinIsCanViewUserRole"
							type="border"
							class="w-30 font-bold mr-3 whitespace-no-wrap"
							@click="$store.dispatch('rolesManagement/toggleRolesCategorySideBar', { status: true })"
							>{{ $t("RoleManagement") }}</vs-button
						>
						<vs-dropdown class="cbs-context-menu cursor-pointer mr-0" vs-trigger-click>
							<vs-button class="font-bold mr-3" type="border" icon-pack="nucleo" icon="nucleo-file-download-94-2">{{ $t("Actions.Download") }}</vs-button>
							<vs-dropdown-menu class="cbs-context-menu-list">
								<vs-dropdown-item>
									<div class="item cbs-context-menu-list__item" @click="handleDownloadEmployee($constant.DOWNLOAD_EMPLOYEE.BIRTH_DAY)">
										Sinh nhật tháng
									</div>
								</vs-dropdown-item>
								<vs-dropdown-item>
									<div class="item cbs-context-menu-list__item" @click="handleDownloadEmployee($constant.DOWNLOAD_EMPLOYEE.KPI)">
										KPIs tháng
									</div>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>

						<vs-button v-if="mixinIsCanCreateEmployee" class="w-30 font-bold" type="filled" @click="addNewData">{{ $t("AddNewEmployee") }}</vs-button>
					</div>
				</div>
				<div class="flex justify-end mt-5">
					<div class="flex flex-col justify-center sm:flex-row items-center text-black mr-3 sm:mr-12">
						<i class="icon-block-status sm:mr-2" style="background-color: #FFFF"></i> <span class="text-center">{{ $t("HaveNotYetAccount") }}</span>
					</div>
					<div class="flex flex-col justify-center sm:flex-row items-center text-black mr-3 sm:mr-12">
						<i class="icon-block-status sm:mr-2 bg-primary-gradient"></i> <span class="text-center">{{ $t("Pending") }}</span>
					</div>

					<div class="flex flex-col justify-center sm:flex-row items-center text-black mr-3 sm:mr-12">
						<i class="icon-block-status sm:mr-2 bg-success"></i> <span class="text-center">{{ $t("Active") }}</span>
					</div>
					<div class="flex flex-col justify-center sm:flex-row items-center text-black">
						<i class="icon-block-status sm:mr-2 bg-gray-4"></i> <span class="text-center">{{ $t("InActive") }}</span>
					</div>
				</div>
				<el-collapse class="cbs-collapse">
					<el-collapse-item name="FilterByDepartment">
						<template slot="title">
							<div>
								<h6 class="uppercase font-bold ml-6">{{ $t("FilterByDepartment") }}</h6>
							</div>
						</template>
						<div class="flex flex-grow flex-wrap justify-start mt-5 overflow-y-scroll md:overflow-visible md:max-h-full" style="max-height: 195px">
							<vs-button
								v-for="(department, idx) in this.$store.state.departments"
								:key="`department${idx}`"
								:color="isActiveDepartment(department.id) ? '#2B59B2' : '#828282'"
								type="border"
								:class="['mr-3 mt-3 border-2', { 'font-bold': isActiveDepartment(department.id), notActive: !isActiveDepartment(department.id) }]"
								@click="handleFilterDepartment(department.id)"
							>
								<p :class="['whitespace-no-wrap', { 'text-primary': isActiveDepartment(department.id) }]">{{ department.name }}</p>
							</vs-button>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>

			<template slot="thead">
				<vs-th class="no-sorter"></vs-th>
				<vs-th sort-key="name" class="custom-sort-filter">{{ $t("FullName") }}</vs-th>
				<vs-th sort-key="dob">{{ $t("DOB") }}</vs-th>
				<vs-th sort-key="email">{{ $t("Email") }}</vs-th>
				<vs-th sort-key="phone">{{ $t("Phone") }}</vs-th>
				<vs-th sort-key="department_id">{{ $t("Department") }}</vs-th>
				<vs-th sort-key="title_id">{{ $t("Title") }}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr class="cursor-default" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td class="w-10 justify-center">
							<span
								:class="[
									'inline-block rounded-full h-3 w-3',
									{ 'bg-success': tr.user && tr.user.is_activated, 'bg-white': !tr.user, 'bg-gray-4': tr.user && !tr.user.is_activated, 'bg-primary-gradient': tr.pending_user }
								]"
							>
							</span>
						</vs-td>
						<vs-td :data-header="$t('FullName')">
							<p class="employee-name font-medium sm:truncate sm:max-w-xs">{{ tr.name }}</p>
						</vs-td>

						<vs-td :data-header="$t('DOB')">
							<p class="employee-dob font-medium">{{ tr.dob | dateTime(userDateFormat) }}</p>
						</vs-td>

						<vs-td :data-header="$t('Email')">
							<p class="employee-email font-medium break-all sm:break-normal sm:truncate sm:max-w-xs" :title="tr.email">{{ tr.email }}</p>
						</vs-td>

						<vs-td :data-header="$t('Phone')">
							<p class="employee-phone font-medium">{{ tr.phone }}</p>
						</vs-td>

						<vs-td :data-header="$t('Department')">
							<p class="employee-department font-medium" :title="tr.departmentName">{{ tr.departmentName }}</p>
						</vs-td>

						<vs-td :data-header="$t('Title')">
							<p class="employee-title font-medium" :title="tr.titleName">{{ tr.titleName }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<EmployeeContextMenu
								type="vertical"
								:employee="tr"
								@onEdit="editData"
								@onDelete="showDeleteConfirm"
								@onBlock="showBlockConfirm"
								@onUnBlock="showBlockConfirm"
								@onCreateAccount="createAccount"
								@onResetPassword="resetPassword"
								@onDivisionCustomer="handleDivisionCustomer"
								@onViewContract="handleViewContract"
								@onDownloadKPI="handleExportMonthlyKPI"
								@onViewStudentData="handleViewStudentData"
								@onViewStudentPoint="handleViewStudentPoint"
								@onViewStudentProfile="handleViewStudentProfile"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />
		<EmployeeDivisionCustomer :isSidebarActive="isShowDivisionCustomer" @closeSidebar="toggleDivisionCustomer" :employee="employeeDivision" />
	</div>
</template>

<script>
import _ from "lodash";
import { withBasicQueries, titlePermissions, userRolePermissions, employeePermissions, departmentPermissions, getUserPermissions } from "@/mixins/mixins.js";
import { mapGetters } from "vuex";
import moduleTitle from "@/store/title/moduleTitle";
import moduleRoles from "@/store/roles/moduleRoles";
import moduleEmployee from "@/store/employee/moduleEmployee";
import employeeGql from "@/http/requests/inside/employee_gql";
import moduleDepartment from "@/store/department/moduleDepartment";
import moduleEvent from "@/store/event/moduleEvent";
import contractGql from "@/http/requests/hr/contract";

import EmployeeFormSidebar from "./EmployeeFormSidebar";
import TitleCategorySidebar from "../../title/TitleCategorySidebar";
import RolesCategorySidebar from "../../roles/RolesCategorySidebar";
import DepartmentCategorySidebar from "../../department/DepartmentCategorySidebar";
import EmployeeContextMenu from "./EmployeeContextMenu";
import EmployeeResetPasswordDialog from "./EmployeeResetPasswordDialog";
import EmployeeDivisionCustomer from "./EmployeeDivisionCustomer";
import EmployeeContractForm from "./EmployeeContractForm";
import EmployeeContractDetailDialog from "./EmployeeContractDetailDialog";
import EmployeeStudentPointForm from "./EmployeeStudentPointForm";
import EmployeeStudentDataForm from "./EmployeeStudentDataForm";
import employeeInsideGql from "@/http/requests/inside/employee_gql";

export default {
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...titlePermissions,
			...userRolePermissions,
			...employeePermissions,
			...departmentPermissions
		})
	],
	components: {
		EmployeeFormSidebar,
		DepartmentCategorySidebar,
		TitleCategorySidebar,
		RolesCategorySidebar,
		EmployeeContextMenu,
		EmployeeResetPasswordDialog,
		EmployeeDivisionCustomer,
		EmployeeContractForm,
		EmployeeContractDetailDialog,
		EmployeeStudentPointForm,
		EmployeeStudentDataForm
	},
	data() {
		return {
			itemsPerPage: 10,
			searchText: "",
			departmentIds: [],

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {},
			showResetPassPopup: false,
			updatePassword: {
				id: null,
				password: "",
				confirmPassword: ""
			},
			isShowDivisionCustomer: false,
			employeeDivision: null,
			isShowContractForm: false,
			isShowContractDetail: false,
			contractFormData: {},
			contractDetailData: {},
			isShowStudentDataForm: false,
			isShowStudentPointForm: false,
			studentData: {},
			employeeFormData: {},
		};
	},
	computed: {
		...mapGetters({
			getParsedEmployees: "employeeManagement/getParsedEmployees"
		}),
		employees() {
			return this.getParsedEmployees || [];
		},
		totalPages() {
			return Math.ceil(this.$store.state.employeeManagement.total / this.$store.state.employeeManagement.limitPerPage);
		},
		employeeDeparmentIdRoute() {
			return this.$route && this.$route.params && this.$route.params.departmentId;
		},
		pageTitleByDeparmentId() {
			const department = (this.$store.state.departments || []).find(department => department.id === Number(this.employeeDeparmentIdRoute)) || {};
			return department.name;
		}
	},
	watch: {
		currentPage() {
			this.getListEmployees();
		},
		"$route.query"() {
			this.getListEmployees();
		},
		pageTitleByDeparmentId() {
			this.setPageTitleByDepartmentId();
		},
		departmentIds() {
			this.getListEmployees();
		}
	},
	methods: {
		async getListEmployees(isRefetch = false) {
			try {
				this.$vs.loading();
				const filter = this.$route.params.filter || {};
				const queryOptions = {
					limit: this.$store.state.employeeManagement.limitPerPage,
					page: this.currentPage,
					orderBy: this.orderBy,
					department_id: this.employeeDeparmentIdRoute,
					department_ids: this.departmentIds,
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch employees
				await this.$store.dispatch("employeeManagement/fetchEmployeesManagement", queryOptions);
				if (this.$refs.table && this.searchText) {
					this.$refs.table.currentx = 1;
				}
				this.$store.commit("employeeManagement/UPDATE_EMPLOYEES_FILTER", filter);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		getListEvents() {
			this.$store.dispatch("eventManagement/fetchEvents");
			this.$store.dispatch("eventManagement/fetchEventsViolation");
		},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("employeeManagement/deleteEmployee", id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteEmployeeSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async editData(id) {
			try {
				this.$vs.loading();
				const response = await employeeGql.getEmployee(id);

				this.sidebarData = {
					...response.employee,
					title_id: _.get(response, "employee.title.id") || null,
					department_id: _.get(response, "employee.department.id") || null
				};
				this.toggleDataSidebar(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		async blockAccount(data) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("employeeManagement/blockAccount", { id: data.id, block: data.block });
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${data.block ? this.$t("BlockAccount") : this.$t("UnBlockAccount")} ${this.$t("Successful").toLowerCase()}`
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async createAccount(id) {
			try {
				this.$vs.loading();

				await this.$store.dispatch("employeeManagement/createAccount", { id });

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("CreateAccount")} ${this.$t("Successful").toLowerCase()}`
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		resetPassword(employee) {
			this.updatePassword = { ...this.updatePassword, ...employee };
			this.toggleResetPasswordPopup(true);
		},
		showBlockConfirm(data) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: `${data.block ? this.$t("BlockAccountConfirm") : this.$t("UnBlockAccountConfirm")} ${data.name} ?`,
				accept: () => this.blockAccount(data),
				cancelText: this.$t("Actions.Cancel"),
				acceptText: this.$t("Actions.Confirm"),
				buttonAccept: "primary vs-button-filled"
			});
		},
		toggleResetPasswordPopup(val = false) {
			this.showResetPassPopup = val;
			if (!val) {
				this.updatePassword = {
					id: null,
					password: "",
					confirmPassword: ""
				};
			}
		},
		async submitResetPassword() {
			try {
				this.$vs.loading();
				await this.$store.dispatch("employeeManagement/resetPassword", { id: this.updatePassword.id, password: this.updatePassword.password });
				this.toggleResetPasswordPopup(false);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("ResetPassword")} ${this.$t("Successful").toLowerCase()}`
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		setPageTitleByDepartmentId() {
			if (this.pageTitleByDeparmentId && this.$listeners && this.$listeners.changeRouteTitle) {
				this.$listeners.changeRouteTitle(this.pageTitleByDeparmentId);
			}
		},
		handleDivisionCustomer(employee) {
			this.employeeDivision = employee;
			this.toggleDivisionCustomer(true);
		},
		toggleDivisionCustomer(val = false) {
			this.isShowDivisionCustomer = val;
		},
		toggleContractForm(val = false) {
			this.isShowContractForm = val;
		},
		toggleContractDetail(val = false) {
			if (!val) {
				this.contractDetailData = {};
			}
			this.isShowContractDetail = val;
		},
		async handleExportMonthlyKPI(emplId) {
			try {
				this.$vs.loading();
				const response = await employeeGql.exportMonthlyKPI(emplId);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleViewContract(empl) {
			this.$vs.loading();
			// 1. Check this employee got any contract
			const { contracts } = await contractGql.laborContractByEmployee({ employee_id: empl.id });
			if (contracts && contracts.length > 0) {
				// 1.1 Yes. Open contract detail's dialog
				console.log("contracts", contracts);
				this.contractDetailData = { employee: empl, contracts: contracts };
				this.toggleContractDetail(true);
			} else {
				// 1.2 No. Open form create contract
				this.contractFormData = { employee: empl };
				this.toggleContractForm(true);
			}
			this.$vs.loading.close();
		},
		handleEditContract(contract) {
			this.contractFormData = contract;
			this.toggleContractForm(true);
		},
		async handleDownloadEmployee(type) {
			let response = null;
			this.$vs.loading();
			try {
				switch (type) {
					case this.$constant.DOWNLOAD_EMPLOYEE.BIRTH_DAY: {
						response = await employeeInsideGql.downloadEmployeeHasBirthday();
						break;
					}
					case this.$constant.DOWNLOAD_EMPLOYEE.KPI: {
						response = await employeeInsideGql.downloadEmployeesKpi();
						break;
					}
				}
				if (response) {
					const fileName = response.split("/");
					let fileNamePre = fileName[fileName.length - 1];
					if (fileNamePre && fileNamePre.indexOf('?') > 0) {
						fileNamePre = fileNamePre.substring(0, fileNamePre.indexOf('?'));
					}
					await this.handleDownloadFile({
						path: response,
						file_name: fileNamePre
					});
				}
			} catch (error) {
				console.log("error", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleFilterDepartment(departmentId) {
			if (this.departmentIds.includes(departmentId)) {
				this.departmentIds = this.departmentIds.filter((id) => id !== departmentId);
			} else {
				this.departmentIds.push(departmentId);
			}
		},
		isActiveDepartment(departmentId) {
			return this.departmentIds.includes(departmentId);
		},
		toggleStudentDataForm(val = false) {
			this.isShowStudentDataForm = val;
		},
		async handleViewStudentData(id) {
			try {
				this.$vs.loading();
				const response = await employeeGql.getEmployee(id);

				this.studentData = response.employee;
				this.isShowStudentDataForm = true;
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleStudentPointForm(val = false) {
			this.isShowStudentPointForm = val;
		},
		async handleViewStudentPoint(id) {
			try {
				this.$vs.loading();
				const response = await employeeGql.getEmployee(id);

				this.employeeFormData = response.employee;
				this.isShowStudentPointForm = true;
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		handleViewStudentProfile(id) {
			this.$router.push({ name: "student-profile", params: { studentId: id } });
		},
	},
	created() {
		this.setPageTitleByDepartmentId();
		this.$store.registerModule("employeeManagement", moduleEmployee);
		this.$store.registerModule("departmentManagement", moduleDepartment);
		this.$store.registerModule("titleManagement", moduleTitle);
		this.$store.registerModule("rolesManagement", moduleRoles);
		this.$store.registerModule("eventManagement", moduleEvent);

		this.$store.dispatch("employeeManagement/setEmployeesSearchQuery", "");
		this.getListEmployees();
		this.getListEvents();
	},
	beforeDestroy() {
		this.$store.unregisterModule("employeeManagement");
		this.$store.unregisterModule("departmentManagement");
		this.$store.unregisterModule("titleManagement");
		this.$store.unregisterModule("rolesManagement");
		this.$store.unregisterModule("eventManagement");
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/cbs/EmployeesManagement.scss";
</style>
